export default __webpack_public_path__ + "static/media/breastfeeding.53979f8f.png";